import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import ContactSalesForm from './ContactSalesForm';
import { GlobalDialogProps } from '../../types';

interface ContactSalesDialogProps extends GlobalDialogProps {
  formSource?: string;
}

const ContactSalesDialog: React.FC<ContactSalesDialogProps> = ({
  onClose,
  formSource = 'Contact Sales Dialog',
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-2xl p-0 gap-0">
        <DialogHeader className="px-6 pt-6 pb-4">
          <DialogTitle>{t('sales.dialog.title')}</DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-6">
          <ContactSalesForm formSource={formSource} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactSalesDialog;
